import { supabase } from '../lib/supabase';

/**
 * Real-time subscription service for production monitoring
 * Manages subscriptions to production areas, workers, shifts, and task assignments
 */
const realtimeService = {
  /**
   * Subscribe to production areas changes
   */
  subscribeToProductionAreas(callback) {
    const channel = supabase?.channel('production_areas_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'production_areas' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to equipment changes
   */
  subscribeToEquipment(callback) {
    const channel = supabase?.channel('equipment_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'equipment' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to production alerts
   */
  subscribeToAlerts(callback) {
    const channel = supabase?.channel('alerts_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'production_alerts' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to workers changes
   */
  subscribeToWorkers(callback) {
    const channel = supabase?.channel('workers_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'workers' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to shifts changes
   */
  subscribeToShifts(callback) {
    const channel = supabase?.channel('shifts_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'shifts' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to task assignments changes
   */
  subscribeToTaskAssignments(callback) {
    const channel = supabase?.channel('task_assignments_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'task_assignments' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to production lines changes
   */
  subscribeToProductionLines(callback) {
    const channel = supabase?.channel('production_lines_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'production_lines' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Unsubscribe from a channel
   */
  unsubscribe(channel) {
    if (channel) {
      supabase?.removeChannel(channel);
    }
  },

  /**
   * Unsubscribe from multiple channels
   */
  unsubscribeAll(channels) {
    channels?.forEach(channel => {
      if (channel) {
        supabase?.removeChannel(channel);
      }
    });
  }
};

export default realtimeService;